import * as React from 'react';
import { SxProps, Typography } from '@mui/material';
import { memo } from 'react';

import { FieldProps, useRecordContext } from 'react-admin';
import { Page } from '../../types';

interface Props extends FieldProps<Page> {
    size?: string;
    sx?: SxProps;
}

const FullNameField = (props: Props) => {
    // const { size } = props;
    const record = useRecordContext<Page>();
    return record ? (
        <Typography
            variant="body2"
            display="flex"
            flexWrap="nowrap"
            alignItems="center"
            component="div"
            sx={props.sx}
        >
            {record.title}
        </Typography>
    ) : null;
};

FullNameField.defaultProps = {
    source: 'title' as const,
    label: 'resources.city_pages.fields.title',
};

export default memo<Props>(FullNameField);
